export enum BroadcastsRoutePath {
    Broadcasts = '/broadcasts',
    Create = '/broadcasts/create'
}
